import { computed, type ComputedRef, type ToRefs } from "vue";
import { useSharedState } from "composables/useSharedState";
import type { RadioGroupProps } from "./radio.types";
import { radioGroupClasses } from "./radio.styles";

export interface UseRadioGroupOptions {
  props: Readonly<RadioGroupProps>;
}

export interface UseRadioGroupReturn {
  state: ToRefs<RadioGroupProps>;
  classes: ComputedRef<ReturnType<typeof radioGroupClasses>>;
  ariaDisabled: ComputedRef<true | undefined>;
}

export const useRadioGroup = (options: UseRadioGroupOptions): UseRadioGroupReturn => {
  const state = useSharedState(options.props);
  const classes = computed(() =>
    radioGroupClasses({
      disabled: state.disabled?.value ? "true" : "false",
      orientation: state.orientation?.value ?? "vertical",
    }),
  );
  const ariaDisabled = computed<true | undefined>(() => (state.disabled?.value ? true : undefined));
  return { state, classes, ariaDisabled };
};
